// extracted by mini-css-extract-plugin
export var accordionContainer = "ProjectsSection-module--accordionContainer--vemr9";
export var projectsContainer = "ProjectsSection-module--projectsContainer--+0PEo";
export var projectsSection = "ProjectsSection-module--projectsSection--Pyqh8";